/* Use one six-size reference for every product family; never count its variants. */
if (!customElements.get('fate-colorway-switcher')) {
  customElements.define('fate-colorway-switcher', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product-details');
      if (!this.scope || !window.ResizeObserver) return;
      this.rail = this.querySelector('.fate-cw__rail');
      this.viewport = this.querySelector('.fate-cw__carousel');
      this.prev = this.querySelector('[data-cw-prev]');
      this.next = this.querySelector('[data-cw-next]');
      this.events = new AbortController();
      const signal = this.events.signal;
      this.prev?.addEventListener('click', event => this.move(-1, event), { signal });
      this.next?.addEventListener('click', event => this.move(1, event), { signal });
      this.rail?.addEventListener('scroll', () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.updateControls(); });
      }, { passive: true, signal });
      this.resize = new ResizeObserver(() => this.sync());
      this.mutations = new MutationObserver(() => this.bindSize());
      this.mutations.observe(this.scope, { childList: true, subtree: true });
      this.bindSize();
    }

    bindSize() {
      const fields = [...this.scope.querySelectorAll('fieldset.variant-option--buttons')];
      const field = fields.find(el => /^(talla|size|tamaño)$/i.test(el.querySelector('legend')?.textContent.trim() || ''));
      if (field === this.field) return;
      this.resize.disconnect();
      this.field = field;
      if (field) {
        this.resize.observe(field);
        this.sync();
      } else {
        this.style.removeProperty('--fate-cw-linked-size');
        this.style.removeProperty('--fate-cw-linked-gap');
      }
    }

    sync() {
      if (!this.field?.isConnected) return;
      const style = getComputedStyle(this.field);
      const width = this.field.getBoundingClientRect().width -
        [style.borderLeftWidth, style.borderRightWidth, style.paddingLeft, style.paddingRight].reduce((sum, value) => sum + (parseFloat(value) || 0), 0);
      if (width <= 0) return;
      const gap = style.columnGap;
      const referenceCount = 6;
      const minimum = matchMedia('(max-width: 749px)').matches ? 44 : 40;
      const size = `${Math.max(minimum, (width - (parseFloat(gap) || 0) * (referenceCount - 1)) / referenceCount)}px`;
      if (this.style.getPropertyValue('--fate-cw-linked-size') !== size) this.style.setProperty('--fate-cw-linked-size', size);
      if (gap !== 'normal' && this.style.getPropertyValue('--fate-cw-linked-gap') !== gap) this.style.setProperty('--fate-cw-linked-gap', gap);
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => this.layoutCarousel());
    }

    layoutCarousel() {
      if (!this.rail || !this.viewport) return;
      const overflow = this.rail.scrollWidth > this.viewport.clientWidth + 1;
      this.classList.toggle('has-overflow', overflow);
      if (this.prev) this.prev.hidden = !overflow;
      if (this.next) this.next.hidden = !overflow;
      const selected = this.rail.querySelector('[aria-current="page"]');
      if (selected) {
        const item = selected.getBoundingClientRect(), rail = this.rail.getBoundingClientRect();
        if (item.left < rail.left) this.rail.scrollLeft += item.left - rail.left;
        else if (item.right > rail.right) this.rail.scrollLeft += item.right - rail.right;
      }
      this.updateControls();
    }

    updateControls() {
      if (!this.rail) return;
      this.prev?.setAttribute('aria-disabled', String(this.rail.scrollLeft <= 1));
      this.next?.setAttribute('aria-disabled', String(this.rail.scrollLeft >= this.rail.scrollWidth - this.rail.clientWidth - 1));
    }

    move(direction, event) {
      if (event.currentTarget.getAttribute('aria-disabled') === 'true') return;
      const step = this.rail.querySelector('li').getBoundingClientRect().width + (parseFloat(getComputedStyle(this.rail).columnGap) || 0);
      const distance = Math.max(step, Math.floor(this.rail.clientWidth / step) * step);
      this.rail.scrollBy({ left: direction * distance, behavior: event.detail === 0 || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    disconnectedCallback() {
      this.resize?.disconnect();
      this.mutations?.disconnect();
      this.events?.abort();
      cancelAnimationFrame(this.layoutFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.field = null;
    }
  });
}
